export default {
  LAMBDA_ENDPOINT: "https://kqfba2wr1l.execute-api.us-east-1.amazonaws.com/prod"
};
